import React, { Component } from 'react';

class TooltipWrapper extends Component {
  componentDidMount() {
    $(this._sp).tooltip();
  }

  render() {
    const { tooltip, children, className } = this.props;
    return (
      <span
        data-toggle="tooltip"
        data-placement="top"
        title={tooltip}
        className={className}
        ref={(sp) => (this._sp = sp)}
      >
        {children}
      </span>
    );
  }
}

export default TooltipWrapper;
